import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $d8rik$useControlledState } from "@react-stately/utils";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $3017fa7ffdddec74$export$8042c6c013fd5226() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isReadOnly = props.isReadOnly; // have to provide an empty function so useControlledState doesn't throw a fit
  // can't use useControlledState's prop calling because we need the event object from the change

  var _ref = (0, $d8rik$useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange),
      _ref2 = _slicedToArray(_ref, 2),
      isSelected = _ref2[0],
      setSelected = _ref2[1];

  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }

  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }

  return {
    isSelected: isSelected,
    setSelected: updateSelected,
    toggle: toggleState
  };
}

export { $3017fa7ffdddec74$export$8042c6c013fd5226 as useToggleState };